import { defineMessages } from 'react-intl';

export default defineMessages({
  failedToUseKeyMessage: {
    id: 'mfa.challenge.securitykey.failedtousekey.label',
    defaultMessage:
      'We’re not sure what went wrong. Try again. If this keeps happening, contact support.',
  },
  securityKeyTooManyAttemptsMessage: {
    id: 'mfa.challenge.securitykey.toomanyattempts.label',
    defaultMessage: 'You’ve reached your rate limit. Try again in a few minutes.',
  },
  webauthnNotSupportedMessage: {
    id: 'mfa.challenge.securitykey.not-supported.label',
    defaultMessage:
      'We’re unable to verify your security key. Make sure your browser supports WebAuthn.',
  },
  webAuthnMalformedConfiguration: {
    id: 'mfa.challenge.webauthn.malformed-configuration.label',
    defaultMessage:
      'We’re unable to authenticate with your security key. Try again. If this keeps happening, contact support.',
    description:
      'Error message displayed when security key challenge failed due to failure to initiate the security key challenge process due to invalid configurations passed to the WebAuthN API and authenticator.',
  },
  webAuthnAborted: {
    id: 'mfa.challenge.webauthn.aborted.label',
    defaultMessage:
      'We’re unable to detect your authentication signal. Try again. If this keeps happening, contact support.',
    description:
      'Error message displayed when security key challenge failed due to the WebAuthn authentication ceremony receiving an abort signal',
  },
  webAuthnAuthenticationIncomplete: {
    id: 'mfa.challenge.webauthn.authentication-incomplete.label',
    defaultMessage: 'You did not complete the authentication process. Try again.',
    description:
      'Error message displayed when security key challenge failed due to failure to complete the process. This is commonly seen if the user cancel out of the authentication, or the process went timeout.',
  },
  webAuthnInvalidDomain: {
    id: 'mfa.challenge.webauthn.invalid-domain.label',
    defaultMessage: 'Your domain does not match the Atlassian domain.',
    description:
      'Error message displayed when security key challenge failed due to the current domain the user is on is invalid',
  },
  webauthnAuthenticationFailed: {
    id: 'mfa.challenge.webauthn.authenticaton-failed.label',
    defaultMessage:
      'Your security key couldn’t complete the authentication. Try again. If this keeps happening, contact support.',
    description:
      'Error message displayed when security key challenge failed due to the authenticator failed to complete the authentication step for unidentifiable reasons',
  },
});
